import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { select } from '@rematch/select';

import { ProfileForm, DEFAULT_VALUES } from '../../atoms/profile-form';
import { ProfileSideNav } from './ProfileSideNav';
import { UserZoneLayout } from '../../layouts/UserZoneLayout';
import { showSuccessErrorAlert } from '../../atoms/alert';
import { getDate, getMonth, getYear } from 'date-fns';

export class Renderer extends React.Component {
  onSubmit = async (values) => {
    const { birth_year, birth_month, birth_day, ...formValues } = values;
    // TODO update BE to match FE object
    const { updateUser, user } = this.props;
    const profession = values.profession ? { id: values.profession } : null;
    const gender = values.gender ? { id: values.gender } : null;
    const education_level = values.education_level ? { id: values.education_level } : null;
    const birthdate = `${String(birth_year).padStart(4, '0')}-${String(Number(birth_month) + 1).padStart(
      2,
      '0',
    )}-${String(birth_day).padStart(2, '0')}`;
    const result = {
      ...formValues,
      profession,
      gender,
      education_level,
      profile_photo: formValues.profile_photo,
      birthdate,
    };

    const response = await updateUser({
      id: user.id,
      data: result,
    });

    showSuccessErrorAlert({
      isOk: response.ok,
      successMessage: <Trans>Profile has been successfully updated.</Trans>,
      errorMessage: response.data['invalid-params'] ? (
        response.data['invalid-params'].map((value) => this.props.t(`${value.name} ${value.reason}.`)).join(',')
      ) : (
        <Trans>Cannot update your profile right now, please try again later.</Trans>
      ),
    });
  };

  getInitialValues = () => {
    const { user } = this.props;
    const values = Object.entries(DEFAULT_VALUES).reduce((items, [key, value]) => {
      if (user[key]) {
        items[key] = typeof user[key].id !== 'undefined' ? user[key].id : user[key];
      } else {
        items[key] = value;
      }
      return items;
    }, {});
    values['profile_photo'] = user.profile_photo;

    if (user.birthdate) {
      // TODO this is hack `+ 'T00:00:00'` because Date is parsing wrong format `2023-01-01` this become different day in timezones places where going back time compared to UTC
      values['birth_day'] = getDate(new Date(user.birthdate + 'T00:00:00'));
      values['birth_month'] = getMonth(new Date(user.birthdate + 'T00:00:00'));
      values['birth_year'] = getYear(new Date(user.birthdate + 'T00:00:00'));
    }
    return values;
  };

  render() {
    return (
      <UserZoneLayout navigation={<ProfileSideNav user={this.props.user} />}>
        <ProfileForm initialValues={this.getInitialValues()} onSubmit={this.onSubmit} />
      </UserZoneLayout>
    );
  }
}

const mapState = (state) => ({
  user: select.session.user(state),
});

const mapDispatch = (dispatch) => ({
  updateUser: (payload) => dispatch.session.updateUser(payload),
});

export const UserProfile = withTranslation()(connect(mapState, mapDispatch)(Renderer));
